import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';

import { DisplayText, useResponsive } from '@sg/garnish';

import { LoyaltyPointsHistoryLogo } from '../LoyaltyPointsHistoryLogo';

export const LoyaltyPointsHistoryHeader = (props: LoyaltyPointsHistoryHeaderProps) => {
  const { availablePoints } = props;

  const { formatNumber } = useIntl();
  const { currentBreakpoint } = useResponsive();

  const formattedPoints = formatNumber(availablePoints);

  if (currentBreakpoint.isXS) {
    return (
      <View style={styles.container}>
        <View style={styles.sgRewards}>
          <LoyaltyPointsHistoryLogo />
        </View>

        <DisplayText sizeMatch={['32']}>
          <FormattedMessage {...messages.subtitle} values={{ points: formattedPoints }} />
        </DisplayText>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <DisplayText sizeMatch={['32']}>
        <FormattedMessage {...messages.pointsHistory} />
      </DisplayText>
    </View>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  sgRewardsLogo: {
    defaultMessage: 'SG Rewards logo',
    description: 'Loyalty | Point History Header | Rewards',
  },
  subtitle: {
    defaultMessage: '{points} points',
    description: 'Loyalty | Point History Header | Subtitle',
  },
  pointsHistory: {
    defaultMessage: 'Points History + FAQ',
    description: 'Loyalty | Point History Header | Points history',
  },
});

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: theme.spacing['6'],
    gap: theme.spacing['4'],
  },
  sgRewards: {
    flex: 1,
    flexDirection: 'row',
    gap: theme.spacing['1'],
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type LoyaltyPointsHistoryHeaderProps = {
  availablePoints: number;
};
